import React, { useState, useEffect } from "react"
import { createPortal } from "react-dom"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import { motion, AnimatePresence } from "framer-motion"
import { FaBars, FaTimes } from "react-icons/fa"

const toggleStyle = {
  padding: "16px 0",
  color: "#233B63",
  background: "none",
  border: "none",
  cursor: "pointer",
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(13, 22, 36, 0.6)",
  zIndex: 60,
}

const drawerStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  width: "82%",
  maxWidth: "320px",
  backgroundColor: "#fff",
  zIndex: 61,
  boxShadow: "-4px 0 16px rgba(0, 0, 0, 0.2)",
  display: "flex",
  flexDirection: "column",
  padding: "24px",
  overflowY: "auto",
}

const drawerCloseStyle = {
  alignSelf: "flex-end",
  background: "none",
  border: "none",
  cursor: "pointer",
  color: "#233B63",
  marginBottom: "24px",
  padding: 0,
}

const drawerLinkStyle = {
  padding: "14px 0",
  borderBottom: "1px solid #e5e7eb",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "uppercase",
  color: "#233B63",
  textDecoration: "none",
}

const Navigation = () => {
  const { settings } = useStaticQuery(query)
  const [isOpen, setIsOpen] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : ""
    return () => {
      document.body.style.overflow = ""
    }
  }, [isOpen])

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === "Escape") setIsOpen(false)
    }
    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [])

  const navItems = settings.pages.map(page => ({
    key: page.slug.current,
    title: page.title,
    to:
      "/" === page.slug.current
        ? page.slug.current
        : "servicos" === page.slug.current
        ? `/bd-service`
        : `/${page.slug.current}`,
    external: false,
  }))

  navItems.push({
    key: "trabalhe-conosco",
    title: "Trabalhe Conosco",
    to: "https://oportunidades.mindsight.com.br/bondmann",
    external: true,
  })

  return (
    <div className="border-t border-gray-300">
      <div className="container">
        <nav className="hidden lg:flex items-center border-l border-r border-gray-300 divide-x divide-gray-300 justify-">
          {navItems.map(item => (
            <Link
              key={item.key}
              className="nav-item"
              partiallyActive={"/" !== item.to}
              to={item.to}
              target={item.external ? "_blank" : undefined}
              activeClassName="is-active"
            >
              <span>{item.title}</span>
            </Link>
          ))}
        </nav>

        <button
          type="button"
          aria-label={isOpen ? "Fechar menu" : "Abrir menu"}
          aria-expanded={isOpen}
          onClick={() => setIsOpen(!isOpen)}
          style={toggleStyle}
          className="lg:hidden flex items-center justify-center"
        >
          {isOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </button>
      </div>

      {mounted &&
        createPortal(
          <AnimatePresence>
            {isOpen && (
              <React.Fragment key="mobile-menu">
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setIsOpen(false)}
                  style={overlayStyle}
                />
                <motion.div
                  initial={{ x: "100%" }}
                  animate={{ x: 0 }}
                  exit={{ x: "100%" }}
                  transition={{ type: "tween", duration: 0.3 }}
                  style={drawerStyle}
                >
                  <button
                    type="button"
                    aria-label="Fechar menu"
                    onClick={() => setIsOpen(false)}
                    style={drawerCloseStyle}
                  >
                    <FaTimes size={24} />
                  </button>
                  <nav style={{ display: "flex", flexDirection: "column" }}>
                    {navItems.map(item => (
                      <Link
                        key={item.key}
                        to={item.to}
                        target={item.external ? "_blank" : undefined}
                        activeClassName="is-active"
                        onClick={() => setIsOpen(false)}
                        style={drawerLinkStyle}
                      >
                        {item.title}
                      </Link>
                    ))}
                  </nav>
                </motion.div>
              </React.Fragment>
            )}
          </AnimatePresence>,
          document.body
        )}
    </div>
  )
}

const query = graphql`
  {
    settings: sanitySettings {
      title
      pages {
        title
        slug {
          current
        }
      }
    }
  }
`

export default Navigation
